export const eventFieldsPermission = [
  {
    key: "pro_name",
    actions: [
      {
        type: "edit",
        roles: [
          "admin",
          "staff",
          "marketing",
          "accountant",
          "check-in-staff",
          "check-in-staff",
          "content",
          "production",
          "guest",
          "so-owner",
          "so-admin",
          "so-staff",
          "so-check-in-staff",
          "so-accountant"
        ]
      } /* only roles can edit this field */,
      {
        type: "view",
        roles: [
          "admin",
          "staff",
          "marketing",
          "accountant",
          "check-in-staff",
          "check-in-staff",
          "content",
          "production",
          "guest",
          "so-owner",
          "so-admin",
          "so-staff",
          "so-check-in-staff",
          "so-accountant"
        ]
      } /* only roles in Array can view this field */
    ]
  },
  {
    key: "poster",
    actions: [
      { type: "edit", roles: ["so-admin"] },
      { type: "view", roles: ["so-admin"] }
    ]
  },
  {
    key: "pro_shortname",
    actions: [
      { type: "edit", roles: ["so-admin"] },
      { type: "view", roles: ["so-admin"] }
    ]
  },
  {
    key: "slug",
    actions: [
      { type: "edit", roles: ["so-admin"] },
      { type: "view", roles: ["so-admin"] }
    ]
  },
  {
    key: "intro",
    actions: [
      { type: "edit", roles: ["so-admin"] },
      { type: "view", roles: ["so-admin"] }
    ]
  },
  {
    key: "pro_shortdesc",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "pro_longdesc",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "datetime",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "timezone",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "venue",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "mode",
    actions: [
      { type: "edit", roles: ["so-admin"] },
      { type: "view", roles: ["so-admin"] }
    ]
  },
  {
    key: "freeevent",
    actions: [
      { type: "edit", roles: ["so-admin"] },
      { type: "view", roles: ["so-admin"] }
    ]
  },
  {
    key: "instruction",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "lobby_intro",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "terms",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "wht_status",
    actions: [
      { type: "edit", roles: ["so-admin", "admin"] },
      { type: "view", roles: ["so-admin", "admin"] }
    ]
  },
  {
    key: "freecode",
    actions: [
      {
        type: "edit",
        roles: [
          "so-owner",
          "so-admin",
        ]
      } /* only roles can edit this field */,
      {
        type: "view",
        roles: [
          "so-owner",
          "so-admin",
        ]
      } /* only roles in Array can view this field */
    ]
  },
  {
    key: "fee",
    actions: [
      {
        type: "view",
        roles: [
          "admin",
          "staff",
          "marketing",
          "accountant",
          "so-owner",
          "so-admin",
          "so-staff",
          "so-check-in-staff",
          "so-accountant",
          'so-guest',
        ]
      } /* only roles can view this field */,
    ]
  },
  {
    key: "int_invoiceno",
    actions: [
      {
        type: "edit",
        roles: [
          "accountant",
          "so-owner",
          "so-admin",
          "so-accountant"
        ]
      } /* only roles can edit this field */,
      {
        type: "view",
        roles: [
          "so-owner",
          "so-admin",
        ]
      } /* only roles in Array can view this field */
    ]
  },
  {
    key: "int_invoicedate",
    actions: [
      {
        type: "edit",
        roles: [
          "accountant",
          "so-owner",
          "so-admin",
          "so-accountant"
        ]
      } /* only roles can edit this field */,
      {
        type: "view",
        roles: [
          "so-owner",
          "so-admin",
          "so-accountant"
        ]
      } /* only roles in Array can view this field */
    ]
  },
  {
    key: "int_remark",
    actions: [
      {
        type: "edit",
        roles: [
          "accountant",
          "so-owner",
          "so-admin",
          "so-accountant"
        ]
      } /* only roles can edit this field */,
      {
        type: "view",
        roles: [
          "accountant",
          "so-owner",
          "so-admin",
          "so-accountant"
        ]
      } /* only roles in Array can view this field */
    ]
  },

  // Seller
  {
    key: "seller_name",
    actions: [
      {
        type: "edit",
        roles: [
          "so-owner",
          "so-admin",
        ]
      } /* only roles can edit this field */,
      {
        type: "view",
        roles: [
          "so-owner",
          "so-admin",
        ]
      } /* only roles in Array can view this field */
    ]
  },
];
